export const FEATURE_NAME = '@zerops/zui/contextual-dialog';
